// extracted by mini-css-extract-plugin
export default {"container":"IconsBlock_container__wl4VR","icons":"IconsBlock_icons__KM3N7","link":"IconsBlock_link__e-uaw","email":"IconsBlock_email__jOsz7"};